// extracted by mini-css-extract-plugin
export default {"layout":"_TZzk","inner":"OViVD","actions":"zFZYp","actionText":"OR3s1","tabs":"otpD0","tabsText":"wU0mv","toolbar":"WTOIS"};